export class Storage {
  constructor() {
    this.prefix = "Jiffy";
    this.storage = window.localStorage;
  }

  storageKey(key) {
    return `${this.prefix}/${key}`;
  }

  get(key) {
    const value = this.storage.getItem(this.storageKey(key));
    try {
      return value === "undefined" ? undefined : JSON.parse(value ?? "");
    } catch (e) {
      return value;
    }
  }

  set(key, value) {
    this.storage.setItem(this.storageKey(key), JSON.stringify(value));
  }

  isExists(key) {
    const value = this.get(key);
    return value !== null && value !== undefined;
  }

  remove(key) {
    this.storage.removeItem(this.storageKey(key));
  }

  clear() {
    this.storage.clear();
  }
}

export const storage = new Storage();
